import * as React from 'react'

export const PhoneOutline = () => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m20.9 14.93-3.98-1.72a1.76 1.76 0 0 0-2.03.55l-1.33 1.56a12.75 12.75 0 0 1-4.88-4.88l1.6-1.3c.59-.5.78-1.36.47-2.06L9.07 3.09a1.79 1.79 0 0 0-2.03-1.01l-3.67.86A1.7 1.7 0 0 0 2 4.66C2 14.23 9.77 22 19.34 22c.86 0 1.57-.55 1.76-1.37l.82-3.67c.2-.82-.23-1.68-1.01-2.03Zm-1.05 5.43a.5.5 0 0 1-.5.43c-8.87 0-16.1-7.27-16.1-16.13 0-.28.16-.47.4-.51l3.66-.86c.04 0 .08-.04.12-.04.2 0 .39.16.5.35l1.69 3.95c.08.23.04.47-.16.62l-1.95 1.6a.6.6 0 0 0-.16.78 13.43 13.43 0 0 0 6.13 6.1c.24.15.55.08.75-.16l1.6-1.95c.15-.2.39-.24.62-.16l3.95 1.68c.23.12.39.35.31.63l-.86 3.67Z"
      fill="#383838"
    />
  </svg>
)
export default PhoneOutline
